export default __webpack_public_path__ + "static/media/Kale-Closeup-800px.77deb5fb.jpg";